import moment from 'moment';
import {strPad} from './string';

export const fromSystemDate = (date) => {
    if (!date) {
        return null;
    }
    return moment(date, 'YYYY-MM-DD');
}

export const fromSystemDateTime = (date) => {
    if (!date) {
        return null;
    }
    return moment(date, 'YYYY-MM-DD HH:mm:ss');
}

export const toHumanDateTime = (date) => {
    if (!date) {
        return null;
    }
    return date.format('DD/MM/YYYY HH:mm:ss');
}

export const toHumanDate = (date) => {
    if (!date) {
        return null;
    }
    return date.format('DD/MM/YYYY');
}

export const toSystemDateTime = (date) => {
    if (!date) {
        return null;
    }
    return date.format('YYYY-MM-DD HH:mm:ss');
}

export const toSystemDate = (date) => {
    if (!date) {
        return null;
    }
    return date.format('YYYY-MM-DD');
}

export const formatSeconds = (val) => {
    val = Number(val);

    const d = Math.floor(val / (3600 * 24));
    const h = Math.floor(val % (3600 * 24) / 3600);
    const m = Math.floor(val % 3600 / 60);
    const s = Math.floor(val % 60);

    const dDisplay = d > 0 ? d + (d === 1 ? ' ' + window.__js_general.date_sm + ', ' : ' ' + window.__js_general.dates_sm + ', ') : '';
    const hDisplay = h > 0 ? h + (h === 1 ? ' ' + window.__js_general.hour_sm + ', ' : ' ' + window.__js_general.hours_sm + ', ') : '';
    const mDisplay = m > 0 ? m + (m === 1 ? ' ' + window.__js_general.minute_sm + ', ' : ' ' + window.__js_general.minutes_sm + ', ') : '';
    const sDisplay = s > 0 ? s + (s === 1 ? ' ' + window.__js_general.second_sm : ' ' + window.__js_general.seconds_sm) : '';

    return dDisplay + hDisplay + mDisplay + sDisplay;
}

export const formatSecondsSmall = (val) => {
    val = Number(val);

    const d = Math.floor(val / (3600 * 24));
    let h = Math.floor(val % (3600 * 24) / 3600);
    let m = Math.floor(val % 3600 / 60);
    let s = Math.floor(val % 60);

    h = strPad(h + '', 2, '0', 'STR_PAD_LEFT');
    m = strPad(m + '', 2, '0', 'STR_PAD_LEFT');
    s = strPad(s + '', 2, '0', 'STR_PAD_LEFT');

    return `${d}ημ. ${h}:${m}:${s}`;
}